import { render, staticRenderFns } from "./DesignModal.vue?vue&type=template&id=381c47b3&scoped=true&"
import script from "./DesignModal.vue?vue&type=script&lang=js&"
export * from "./DesignModal.vue?vue&type=script&lang=js&"
import style0 from "./DesignModal.vue?vue&type=style&index=0&id=381c47b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381c47b3",
  null
  
)

export default component.exports